import type { ReactNode } from "react";

import { useHydrated } from "~/hooks/useHydrated";

type Props = {
  fallback?: ReactNode;
  children: ReactNode;
};

const ClientOnly = ({ children, fallback = null }: Props) => {
  const isHydrated = useHydrated();
  return isHydrated ? <>{children}</> : <>{fallback}</>;
};

export default ClientOnly;
